import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Protection: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M27 12.88c0-1.39-.2-2.73-.54-4A16.93 16.93 0 0 1 16 4.83 16.93 16.93 0 0 1 5.54 8.87 15.02 15.02 0 0 0 16 27.34a15 15 0 0 0 11-14.46Zm-7.81-.58a1 1 0 0 1 1.62 1.16l-5 7a1 1 0 0 1-1.52.13l-3-3a1 1 0 0 1 1.42-1.42l2.16 2.17 4.32-6.04Zm9.81.58a17 17 0 0 1-12.75 16.47 1 1 0 0 1-.5 0A17 17 0 0 1 3.85 7.57l.06-.15a1 1 0 0 1 .9-.54H5c4 0 7.62-1.56 10.31-4.1l.16-.13a1 1 0 0 1 1.22.12 14.95 14.95 0 0 0 10.5 4.11l.16.01a1 1 0 0 1 .8.68c.55 1.67.85 3.46.85 5.31Z"
    />
  </Icon>
);
